import type { ProfileOccupationChoices_OccupationChoice as ProfileOccupationChoice } from '__generated__/graphql-types-do-not-use';

export type Occupation = {
  id: string;
  name: string;
  __typename?: string;
};

/* 
  The ProfileOccupationChoices_OccupationChoice type doesn't match the occupation preferences type that is used
  to post updates with. Due to this mismatch, we need to covert the ProfileOccupationChoices_OccupationChoice objects 
  to the occupation preferences type.
*/

export const convertProfileOccupationChoiceToPreferenceNaptimeType = (
  occupations: Array<ProfileOccupationChoice>
): Array<Occupation> => {
  return occupations.map((occupation) => {
    return { id: occupation.id, name: occupation.occupationName };
  });
};
